import api from '@/services/api'
import useLoading from '@/composables/useLoading'
import useResponse from '@/composables/useResponse'
import { computed, ref, watch } from '@vue/composition-api'

export default function useOrder() {
  const list = ref([])
  const pagination = ref({
    page: 1,
    perPage: 2,
    totalPage: 1,
  })

  const { isLoading, startLoading, finishLoading } = useLoading()

  const tableColumns = [
    { key: 'id', label: '#' },
    { key: 'state', label: 'State' },
    { key: 'total', label: 'Total' },
    { key: 'products', label: 'Products', formatter: products => products.reduce((acc, p) => `${acc}, ${p.product.name}`, '').slice(1) },
    { key: 'created_at', label: 'Order Time' },
    { key: 'actions', label: 'Actions' },
  ]

  const statuses = Object.freeze({
    1: {
      value: 'NONE',
      class: 'bg-secondary',
    }, //   secondary
    2: {
      value: 'PAYED',
      class: 'bg-info',
    }, // primary
    3: {
      value: 'READY',
      class: 'bg-primary',
    }, // primary darken-2
    4: {
      value: 'RECEIVING',
      class: 'bg-warning',
    }, // warning
    5: {
      value: 'DONE',
      class: 'bg-success',
    },
    // NONE - zakaz to'lanmagan
    // PAYED - zakaz to'langan, lekin hali skladga yetib bormagan
    // READY - zakaz sklad ichida
    // RECEIVING - klient zakaz olib ketdi, lekin hammasini emas
    // DONE - polniy olib ketdi
  })

  const paginationMeta = computed(() => ({
    from: pagination.value.perPage * (pagination.value.page - 1) + (list.value.length ? 1 : 0),
    to: pagination.value.perPage * (pagination.value.page - 1) + list.value.length,
    of: pagination.value.totalPage,
  }))

  watch(() => pagination.value.page, () => {
    findAll()
  })

  async function findAll() {
    try {
      startLoading()
      const response = useResponse(
        await api.order.findAll({
          params: {
            limit: pagination.value.perPage,
            page: pagination.value.page,
          },
        }),
      )
      list.value = response.documents
      pagination.value.totalPage = response.pagination.totalPage
    } finally {
      finishLoading()
    }
  }

  function findOne({ id }) {
    return api.order.findOne({ id })
  }

  function edit({ id, body }) {
    return api.order.edit({ id, body })
  }

  return {
    list,
    pagination,
    paginationMeta,
    tableColumns,
    isLoading,
    statuses,

    // create,
    edit,
    findOne,
    findAll,
  }
}
